import React from "react";

export const FormAccident = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험사명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.insuranceSvcInfo.insuranceCorpName"
                            placeholder="보험사명"
                            value={formData?.member?.insuranceSvcInfo?.insuranceCorpName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
